/**
 * Endless ticker of the technology M1NT stands on. Keeps moving under the cursor; static when motion is reduced.
 *
 * Seamless loop: the track holds two identical rows and slides by exactly one row's width, so the
 * second row lands where the first began. Each row repeats the items enough times to be wider than
 * any screen, otherwise a gap would open at the end of the track.
 */
const COPIES_PER_ROW = 4

export default function TrustMarquee({ items }) {
  const renderRow = (rowIndex) => (
    <ul
      className="m1nt-marquee-row flex shrink-0 items-center"
      aria-hidden={rowIndex > 0 ? 'true' : undefined}
    >
      {Array.from({ length: COPIES_PER_ROW }).flatMap((_, copy) =>
        items.map((item) => (
          <li
            key={`${copy}-${item}`}
            aria-hidden={copy > 0 ? 'true' : undefined}
            className="flex items-center whitespace-nowrap font-m1-mono text-[12px] uppercase tracking-[0.18em] text-m1-ink-soft"
          >
            <span className="px-8">{item}</span>
            <span className="h-1 w-1 rotate-45 bg-m1-muted" aria-hidden="true" />
          </li>
        ))
      )}
    </ul>
  )

  return (
    <div
      className="m1nt-marquee relative overflow-hidden border-y border-m1-line-soft py-5"
      role="group"
      aria-label="Trusted technology"
    >
      <div className="m1nt-marquee-track flex w-max">
        {renderRow(0)}
        {renderRow(1)}
      </div>
    </div>
  )
}
